import { defineStore } from 'pinia';
import { getSenvenDays } from 'core';

export const useTimeStore = defineStore('time', {
  state: () => ({
    startTime: sessionStorage.home_start_time || getSenvenDays().startTime,
    endTime: sessionStorage.home_end_time || getSenvenDays().endTime,
  }),
  actions: {
    setTime(startTime: string, endTime: string) {
      this.startTime = startTime;
      this.endTime = endTime;
    },
  },
});
